interface LogoProps {
  color?: string
  width?: number
  height?: number
  alternative?: boolean
  className?: string
}

export default function Logo({
  color = 'white',
  width = 150,
  height = 50,
  alternative = false,
  className = '',
}: LogoProps) {
  return !alternative ? (
    <svg
      width={width}
      height={height}
      viewBox="0 0 380.73 128.2"
      id="ircamamplify"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      className={`text-center mx-auto block ${className}`}
    >
      <g>
        <g>
          <g>
            <path
              className="logo-path"
              d="m0,7.53V0h7.53v7.53H0Zm0,43.35V13.2h7.53v37.68H0Z"
            />
            <path
              className="logo-path"
              d="m15.05,50.87V13.2h7.53v3.76h3.76v-3.76h9.43v7.53h-9.43v3.76h-3.76v26.39h-7.53Z"
            />
            <path
              className="logo-path"
              d="m47.07,50.87v-3.76h-3.76v-3.76h-3.76v-22.63h3.76v-3.76h3.76v-3.76h18.86v3.76h3.76v3.76h3.76v7.55h-7.53v-3.79h-3.79v-3.76h-11.31v3.76h-3.76v15.1h3.76v3.76h11.31v-3.76h3.79v-3.79h7.53v7.55h-3.76v3.76h-3.76v3.76h-18.86Z"
            />
            <path
              className="logo-path"
              d="m88.52,50.87v-3.76h-3.76v-3.76h-3.76v-7.55h3.76v-3.76h7.53v-3.76h15.1v-3.79h-3.79v-3.76h-11.31v3.76h-11.29v-3.76h3.76v-3.76h3.76v-3.76h18.86v3.76h3.76v3.76h3.76v30.15h-7.53v-3.76h-3.79v3.76h-15.08Zm15.08-7.53v-3.76h3.79v-7.55h-3.79v3.76h-13.2v7.55h13.2Z"
            />
            <path
              className="logo-path"
              d="m122.44,50.87V13.2h7.53v3.76h3.76v-3.76h11.31v3.76h7.55v-3.76h15.08v3.76h3.76v3.76h3.79v30.15h-7.55v-26.39h-3.76v-3.76h-7.55v3.76h-3.76v26.39h-7.55v-26.39h-3.76v-3.76h-7.55v3.76h-3.76v26.39h-7.53Z"
            />
          </g>
          <g>
            <path
              className="logo-path"
              d="m9.74,109.15v-4.76h-4.76v-4.76H.23v-9.54h4.76v-4.76h9.51v-4.76h19.09v-4.79h-4.79v-4.76h-14.3v4.76H.23v-4.76h4.76v-4.76h4.76v-4.76h23.84v4.76h4.76v4.76h4.76v38.11h-9.51v-4.76h-4.79v4.76H9.74Zm19.05-9.51v-4.76h4.79v-9.54h-4.79v4.76H12.12v9.54h16.68Z"
            />
            <path
              className="logo-path"
              d="m52.6,109.15v-47.62h9.51v4.76h4.76v-4.76h14.3v4.76h9.54v-4.76h19.05v4.76h4.76v4.76h4.79v38.11h-9.54v-33.35h-4.76v-4.76h-9.54v4.76h-4.76v33.35h-9.54v-33.35h-4.76v-4.76h-9.54v4.76h-4.76v33.35h-9.51Z"
            />
            <path
              className="logo-path"
              d="m128.8,128.2V61.53h9.51v4.76h4.76v-4.76h19.09v4.76h4.76v4.76h4.76v28.6h-4.76v4.76h-4.76v4.76h-19.09v-4.76h-4.76v23.81h-9.51Zm28.56-28.56v-4.76h4.79v-19.09h-4.79v-4.76h-14.3v4.76h-4.76v19.09h4.76v4.76h14.3Z"
            />
            <path
              className="logo-path"
              d="m181.17,109.15V42.45h9.51v66.7h-9.51Z"
            />
            <path
              className="logo-path"
              d="m200.19,54.37v-9.51h9.51v9.51h-9.51Zm0,54.78v-47.62h9.51v47.62h-9.51Z"
            />
            <path
              className="logo-path"
              d="m223.97,109.15v-40.48h-7.13v-7.13h7.13v-14.3h4.76v-4.79h14.3v9.54h-9.51v9.54h9.51v7.13h-9.51v40.48h-9.54Z"
            />
            <path
              className="logo-path"
              d="m250.15,128.2v-9.54h14.27v-9.51h4.79v-9.51h-4.79v-9.54h-4.76v-9.51h-4.76v-9.54h-4.76v-9.51h9.51v9.51h4.76v9.54h4.79v9.51h9.51v-9.51h4.79v-9.54h4.76v-9.51h9.51v9.51h-4.76v9.54h-4.76v9.51h-4.76v9.54h-4.79v9.51h-4.76v9.51h-4.76v4.76h-4.79v4.79h-14.27Z"
            />
            <path
              className="logo-path"
              d="m299.83,109.15v-9.51h9.51v9.51h-9.51Z"
            />
            <path
              className="logo-path"
              d="m318.85,54.37v-9.51h9.51v9.51h-9.51Zm0,54.78v-47.62h9.51v47.62h-9.51Z"
            />
            <path
              className="logo-path"
              d="m347.38,109.15v-4.76h-4.76v-4.76h-4.76v-28.6h4.76v-4.76h4.76v-4.76h23.84v4.76h4.76v4.76h4.76v28.6h-4.76v4.76h-4.76v4.76h-23.84Zm19.05-9.51v-4.76h4.79v-19.09h-4.79v-4.76h-14.3v4.76h-4.76v19.09h4.76v4.76h14.3Z"
            />
          </g>
        </g>
      </g>
    </svg>
  ) : (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 513.14 513"
      className={`block text-center ${className}`}
    >
      <g>
        <path
          id="Rectangle_719"
          d="m314.1.5h0c10.6,0,19.2,8.6,19.2,19.2v473.6c0,10.6-8.6,19.2-19.2,19.2h0c-10.6,0-19.2-8.6-19.2-19.2V19.7c0-10.6,8.6-19.2,19.2-19.2Z"
          fill={color}
        />
        <path
          id="Rectangle_720"
          d="m429.3,102.9h0c10.6,0,19.2,8.6,19.2,19.2v268.8c0,10.6-8.6,19.2-19.2,19.2h0c-10.6,0-19.2-8.6-19.2-19.2V122.1c0-10.6,8.6-19.2,19.2-19.2Z"
          fill={color}
        />
        <path
          id="Rectangle_721"
          d="m198.9,141.3h0c10.6,0,19.2,8.6,19.2,19.2v192c0,10.6-8.6,19.2-19.2,19.2h0c-10.6,0-19.2-8.6-19.2-19.2v-192c0-10.6,8.6-19.2,19.2-19.2Z"
          fill={color}
        />
        <path
          id="Rectangle_722"
          d="m83.7,51.7h0c10.6,0,19.2,8.6,19.2,19.2v371.2c0,10.6-8.6,19.2-19.2,19.2h0c-10.6,0-19.2-8.6-19.2-19.2V70.9c0-10.6,8.6-19.2,19.2-19.2Z"
          fill={color}
        />
      </g>
    </svg>
  )
}
